/* eslint-disable react/require-default-props */
import React, { Component } from 'react';

interface PinProps {
    id?: number;
    pin?: string;
    isactive?: string;
    highlighted?: string;
    x: number;
    y: number;
    width: number;
    height: number;
    num?: string;
    label?: string;
    onMouseOver?: (event: React.MouseEvent<SVGElement>) => void;
    onMouseOut?: (event: React.MouseEvent<SVGElement>) => void;
    onClick?: (event: React.MouseEvent<SVGElement>) => void;
}
interface PinState { }

export default class Pin extends Component<PinProps, PinState> {
    renderHighlight() {
        if (this.props.highlighted === 'true') {
            return (
                <animate
                    attributeType="XML"
                    attributeName="fill"
                    values="#91c5ea;#91c5ea;#eee;#eee;"
                    dur="1.0s"
                    repeatCount="indefinite"
                />
            );
        }
        return null;
    }

    render() {
        let x = this.props.x + this.props.width / 4;
        if (this.props.label.length > 1) {
            x = this.props.x + this.props.width / 8;
        }
        return (
            <g>
                <rect
                    {...this.props}
                    data-pin-num={this.props.pin}
                    className={this.props.isactive === 'true' ? 'active pin' : 'pin'}
                >
                    {this.renderHighlight()}
                </rect>
                <text
                    className="pinLabel"
                    x={x + this.props.width / 4}
                    y={this.props.y + this.props.width * 0.8}
                    fill="#666"
                    fontFamily="monospace"
                    textAnchor="middle"
                    width={this.props.width}
                    fontSize={12}
                >
                    {this.props.label}
                </text>
            </g>
        );
    }
}
